<template>
  <div
    class="placeholder"
    :style="`position: relative; width: calc(${count} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom));`"
    >
    <div class="bottom-right">
      <slot name="bottom-right"/>
    </div>
    <div style="placeholder-swap-arrow-wrapper" v-if="taktarea_drag && hover">
      <v-icon :class="`swap-arrow ${wbgroup_drag_handle?'swap-arrow-wbgroup':'swap-arrow-2'}`">swap_vert</v-icon>
    </div>
  </div>
</template>
<script>
export default {
  props: ['count', 'hover', 'taktarea_drag', 'wbgroup_drag_handle'],
  data: () => ({
  }),
}
</script>
<style>
.placeholder {
  transition: none;
  display: flex;
  flex-shrink: 0;
  will-change: width, height;
  justify-content: flex-end;
}
.bottom-right {
  position: absolute;
  right: 0px;
  bottom: 0px;
  will-change: 'width';
}
.placeholder-swap-arrow-wrapper {
  text-align: right;
}
.swap-arrow {
  margin-top: 10px;
  margin-right: 20px;
  cursor: row-resize;
  zoom: var(--taktplan_zoom);
}
</style>
